import * as c from '../constants';


const CHILDREN_INIT_STATE = {};


export default function (state = CHILDREN_INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_RESET: {
      return CHILDREN_INIT_STATE;
    }

    case c.HOTKEY_TMP_GET_CHILDREN: {
      const { payload: tabKey } = action;
      return {
        ...state,
        [tabKey]: childReducer(state[tabKey], action)
      }
    }

    case c.HOTKEY_TMP_SET_CHILDREN: {
      const { payload: { tabKey } } = action;
      return {
        ...state,
        [tabKey]: childReducer(state[tabKey], action)
      }
    }
  
    default: {
      return state;
    }
  }
}


const CHILD_INIT_STATE = {
  isFetching: false,
  items: [],
  initial_items: []
};


function childReducer(state = CHILD_INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_GET_CHILDREN: {
      return {
        ...state,
        isFetching: true,
      }
    }

    case c.HOTKEY_TMP_SET_CHILDREN: {
      const { payload: { children } } = action;
      return {
        ...state,
        isFetching: false,
        items: children,
        initial_items: initialItemsReducer(state.initial_items, action)
      }
    }
  
    default: {
      return state;
    }
  }
}


function initialItemsReducer(state = [], action) {
  switch (action.type) {
    case c.HOTKEY_TMP_SET_CHILDREN: {
      const { initial, payload: { children } } = action;
      
      if (!initial) {
        return state;
      }

      return children;
    }
  
    default: {
      return state;
    }
  }
}


